import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {Scrollbars} from 'react-custom-scrollbars';

import classnames from 'classnames';

import defaultStyles from './DataDrivenTable.scss';

const defaultFormatFn = (value) => value;
const defaultKeyFn = (value, index) => {
    if (value.id === undefined) return index;
    return value.id;
};
// suggests that all items are equal by returning 0, doesn't change the given order.
const defaultSortFn = () => 0;


export default class DataDrivenTable extends PureComponent {
    static propTypes = {
        data: PropTypes.object.isRequired,
        rowKeyFn: PropTypes.func,
        sortFn: PropTypes.func,
        styles: PropTypes.object,
        isScrollable: PropTypes.bool,
    };

    static defaultProps = {
        rowKeyFn: defaultKeyFn,
        sortFn: defaultSortFn,

        isScrollable: false,
        styles: null,
    };

    // TODO: rewrite this to use a merged stylesheet as soon as you find where to store it without modifying the props.
    // See: helpers/mergeStyles.js
    getClassname = (classname, extra = []) => {
        const extraStyles = extra.map((name) => this.getClassname(name));

        const {styles} = this.props;

        if (!styles || !styles[classname]) return classnames(extraStyles, defaultStyles[classname]);

        return classnames(styles[classname], extraStyles, defaultStyles[classname]);
    };

    renderItem = (itemData, options) => {
        if (options.allowEmpty === undefined) options.allowEmpty = true;
        if (options.formatFn === undefined) options.formatFn = defaultFormatFn;
        if (itemData === undefined && !options.allowEmpty) throw new Error(`One of the table rows lacks a required key ${options.key}!`);

        const formattedItemData = (itemData || itemData === 0) ? options.formatFn(itemData) : '';

        return (
            <td
                key={options.key}
                className={this.getClassname('item', [options.key])}
            >
                {formattedItemData}
            </td>
        );
    };

    renderRow = (headerData, rowData, index) => {
        const renderedRow = headerData.map(headerItem => {
            const options = Object.assign({}, headerItem);
            return this.renderItem(rowData[options.key], options);
        });

        const {rowKeyFn} = this.props;

        return (
            <tr
                className={this.getClassname('row')}
                key={rowKeyFn(rowData, index)}
            >
                {renderedRow}
            </tr>
        );
    };

    renderHeader = (headerData) => {
        const renderedHeader = headerData.map(item => (
            <th
                key={item.key}
                className={this.getClassname('headerItem', [item.key])}
            >
                {item.label}
            </th>
        ));

        return renderedHeader;
    };

    renderTable = (data) => {
        const {sortFn} = this.props;

        const {header, rows} = data;
        const renderedHeader = this.renderHeader(header);
        const renderedRows = rows.sort(sortFn).map(
            (row, index) => this.renderRow(data.header, row, index),
        );

        return (
            <table className={this.getClassname('table')}>
                <thead>
                    <tr className={this.getClassname('headerRow')}>{renderedHeader}</tr>
                </thead>
                <tbody>
                    {renderedRows}
                </tbody>
            </table>
        );
    };


    render() {
        const {isScrollable, data} = this.props;

        if (isScrollable) {
            return (
                <Scrollbars className={this.getClassname('scrollbar')}>
                    <div className={this.getClassname('container')}>
                        {this.renderTable(data)}
                    </div>
                </Scrollbars>
            );
        }
        return (
            <div className={this.getClassname('container')}>
                {this.renderTable(data)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/DataDrivenTable/DataDrivenTable.jsx